import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employees: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    fetchEmployeesStart(state) {
      state.status = 'loading';
    },
    fetchEmployeesSuccess(state, action) {
      state.status = 'succeeded';
      state.employees = action.payload;
    },
    fetchEmployeesFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    createEmployee(state, action) {
      state.employees.push(action.payload);
    },
    updateEmployee(state, action) {
      const { id, updatedEmployee } = action.payload;
      const existingEmployee = state.employees.find((employee) => employee.id === id);
      if (existingEmployee) {
        Object.assign(existingEmployee, updatedEmployee);
      }
    },
    deleteEmployee(state, action) {
      const id = action.payload;
      state.employees = state.employees.filter((employee) => employee.id !== id);
    },
  },
});

export const {
  fetchEmployeesStart,
  fetchEmployeesSuccess,
  fetchEmployeesFailure,
  createEmployee,
  updateEmployee,
  deleteEmployee,
} = employeesSlice.actions;

export default employeesSlice.reducer;

export const selectAllEmployees = (state) => state.employees.employees;
export const selectStatus = (state) => state.employees.status;
